// Translation: Utility > Loading error (Russian)
export default Object.freeze({
	description: '',
	title: ''
})
